import { EntityId } from "../charting_library";
import { AlertMarkUpStyle, BuildUpItemToolStyle, FvgExtend, LineStyle, LineWidth, OpenToolStyle, PDStyle, PivotSignificance, PoiExtend, PoiItemStyle, PoiPreferences, PoiSignificance, PoiStyle, PoiStyleType, RaidableToolStyle, SbPoiItemStyle, TargetsTxtFlgs, TextStyle, TextStyleProps, ToolStyle, TxtAlign } from "../config/smpa";
import { hub, UpdateViewField } from "../hub";
import { TargetsPreview, TVContext } from "../hub/context";
import { isSet } from "../storage";
import { color_transparent, halign_center, halign_left, halign_right, hrTool, rectTool, tlTool, tvpoint, valign_bottom, valign_center, valign_top, zOrderType } from "../tv";
import { LevelLiqType, MarkOpenType, MarkToolCat, PoiToolType, SmpaBuildUpInfo, SmpaBuildUpTargetInfo, SmpaFvgInfo, SmpaLevelInfo, SmpaOpenInfo, SmpaPoiType, SmpaSessionInfo, SmpaStructPoiInfo, SmpaSweepInfo, SmpaTargetInfo, SmpaTFInfo, SmpaToolBase, SmpaToolInfo, SmpaToolInfoTools, SmpaToolMark, SmpaZoneInfo, StructBosLine } from "./smpainfo";
import { fractalStructTool, IDrawn, simpleStructTool, structTool, swingStructTool } from "./struct";
import { markToolsStyles, styleSet } from "./styles";
import { markToolsSet } from "./toolsset";

const TF_Ids = 1;
const TF_QMs = 2;
const TF_Levels = 4;
export class markTools {
    tvd: TVContext;
    styles: markToolsStyles;
    tools: markToolsSet;
    lastBePoi: SmpaStructPoiInfo;
    lastBuPoi: SmpaStructPoiInfo;
    lastReBePoi: SmpaStructPoiInfo;
    lastReBuPoi: SmpaStructPoiInfo;
    drawnTools = new Set<number>();
    drawnBuildUps = new Map<number, tlTool>();
    drawnBuildUpLevels = new Set<number>();
    structs: structTool[] = [];
    lastBosAt = 0;
    recentPoi: SmpaStructPoiInfo;
    constructor(tvd: TVContext) {
        this.tvd = tvd;
        this.styles = new markToolsStyles();
        this.tools = new markToolsSet(this);
        const fractal = new fractalStructTool(this.tvd);
        this.structs.push(new swingStructTool(this.tvd, fractal));
        this.structs.push(fractal);
        if (hub.options.isAdmin)
            this.structs.push(new simpleStructTool(this.tvd));
        this.updateView();
        this.tvd.tv.subscribe("panes_height_changed", () => {
            this.onViewPortChanged();
        });
    }
    onViewPortChanged() {
        for (const str of this.structs)
            str.onViewPortChanged();
    }

    updateView(init = false, field = UpdateViewField.Some): boolean {
        let rebuild = init;
        if (init)
            this.clear();
        if (!rebuild)
            rebuild = field != UpdateViewField.Color;
        this.structs.forEach(x => { if (x.updateView()) rebuild = true; });
        this.styles.updateView();
        if (!rebuild) {
            for (const r of this.tools.dirTools)
                if (r.txt)
                    r.tool.setColor(color_transparent, r.style.getText(r.isBull));
                else
                    r.tool.setColor(r.style.get(r.isBull), r.style.getText(r.isBull));

            for (const s of this.tools.sessions) {
                let color = this.styles.asesColor;
                if (s.type == LevelLiqType.F)
                    color = this.styles.fsesColor;
                else if (s.type == LevelLiqType.L)
                    color = this.styles.lsesColor;
                else if (s.type == LevelLiqType.N)
                    color = this.styles.nsesColor;
                s.tool.setColor(color);
            }
        }
        return rebuild;
    }
    public isMostRecent(p: SmpaStructPoiInfo) {
        if (p.rf == -1)
            return p.ib ? this.lastBuPoi == p : this.lastBePoi == p;
        else
            return p.ib ? this.lastReBuPoi == p : this.lastReBePoi == p;
    }
    private debugPoi: SmpaStructPoiInfo;
    markPhases(id: EntityId) {
        for (var tool of this.tools.dirTools) {
            if (tool.tool.id == id) {
                this.debugPoi = tool.p;
                break;
            }
        }

    }
    private buildPoiDebug(poi: rectTool, mi: SmpaTFInfo, p: SmpaStructPoiInfo) {
        if (!this.debugPoi || this.debugPoi != p)
            return;
        addLine(p.m_in, this.tools, this.styles.sbpoi, this.tvd, 'init', halign_left);
        //addLine(p.mm_in, this.tools, this.styles.sbpoi, this.tvd, 'max init', halign_right);
        addLine(p.m_mi, this.tools, this.styles.sbpoi, this.tvd, 'mit', halign_left);
        addLine(p.m_co, this.tools, this.styles.sbpoi, this.tvd, 'co', halign_left);
        //addLine(p.mm_mi, this.tools, this.styles.poi, this.tvd, 'max mit', halign_right);
        //addLine(p.m_co, this.tools, this.styles.poi, this.tvd, 'co', halign_center);
        function addLine(line: StructBosLine, tools: markToolsSet, style: styleSet, tvd: TVContext, t: string, align: string) {
            if (line == null)
                return;
            const poi = new tlTool(tvd, style.getText(p.ib), 2, style.getText(p.ib), LineStyle.solid);
            poi.setAligns(valign_center, align, 10);

            poi.build(line.f, line.t);
            poi.setText(t);// + '_' + markTools.getName(mi, p))
            tools.addDirTool(style, poi, p.ib);
        }
    }
    private buildMarkUp(mi: SmpaTFInfo) {
        const dispAlert = hub.displayAlert;
        if (!dispAlert || !this.tvd.isTvReady())
            return;
        if (dispAlert.ticker.id != this.tvd.tid)
            return;
        for (const msg of dispAlert.msgs) {
            if (this.tvd.getTimeFrameInfo().o != msg.tf)
                continue;
            if (!msg.f)
                continue;
            const s = this.styles.alerts.style as AlertMarkUpStyle;
            const tool = new rectTool(this.tvd, this.styles.alerts.get(false), s.lWidth, null, false, false, false);
            tool.zOrder = zOrderType.top;
            tool.build(msg.f, msg.t);

            this.tools.addDirTool(this.styles.alerts, tool, false);

            const txt = new tlTool(this.tvd, color_transparent, LineWidth.w1, this.styles.alerts.get(false));
            const txtSize = 8;
            let p = 0;
            if (dispAlert.ib) {
                txt.setAligns(valign_bottom, halign_right, txtSize);
                p = Math.min(msg.f.p, msg.t.p);
            }
            else {
                txt.setAligns(valign_top, halign_right, txtSize);
                p = Math.max(msg.f.p, msg.t.p);
            }
            txt.build({ p: p, t: msg.f.t }, { p: p, t: msg.t.t });
            txt.setText(msg.message);
            this.tools.addDirTool(this.styles.alerts, txt, dispAlert.ib, true);
        }
    }
    private buildPremiumDiscount(mi: SmpaTFInfo, bias: boolean) {
        if (!this.styles.pd.on)
            return;
        if (!mi.pd)
            return;
        if (bias != null && bias != mi.pd.ib)
            return;
        const pds = hub.smcConfig.pd;
        const p = mi.pd;
        if (pds.style == PDStyle.Blocks) {
            let poi = new rectTool(this.tvd, this.styles.pd.get(false), LineWidth.w0);
            let from = {
                t: p.f,
                p: p.h,
            }
            let to = {
                t: p.t,
                p: (p.h + p.l) / 2
            };
            poi.build(from, to);
            this.tools.addDirTool(this.styles.pd, poi, false);
            from = {
                t: from.t,
                p: to.p
            };
            to = {
                t: to.t,
                p: p.l
            };
            poi = new rectTool(this.tvd, this.styles.pd.get(true), LineWidth.w0);
            poi.build(from, to);
            this.tools.addDirTool(this.styles.pd, poi, true);
        } else if (pds.style == PDStyle.Line) {
            const poi = new hrTool(this.tvd, this.styles.pd.getText(p.ib), pds.lWidth, false, pds.lStyle);
            poi.build({
                t: mi.lb,
                p: (p.h + p.l) / 2
            });
            this.tools.addDirTool(this.styles.pd, poi, p.ib);
        }

    }
    private buildPOIs(mi: SmpaTFInfo, vals: SmpaStructPoiInfo[], drawnPoiLabels: Map<string, tlTool>[]) {
        const ps = hub.smcConfig.poi;
        if (!ps.on)
            return;

        let maxpois = Math.max(ps.maxol, 1);
        const significance = ps.s;
        const pids: Set<number> = ps.sb.hideOnRefine ? new Set<number>() : null;
        for (const p of vals) {
            if (p.ot == SmpaPoiType.ISB)
                continue;
            let mostRecent = false;
            if (p.rf == -1) {
                if (p.ib && this.lastBuPoi == null)
                    mostRecent = true;
                else if (!p.ib && this.lastBePoi == null)
                    mostRecent = true;
            } else {
                if (p.ib && this.lastReBuPoi == null)
                    mostRecent = true;
                else if (!p.ib && this.lastReBePoi == null)
                    mostRecent = true;
            }
            const isBos = markTools.isLastBos(p);
            if (isBos)
                this.lastBosAt = p.f.t;
            else if (significance && (p.s & significance) == 0)
                continue;

            let withBosStyle: PoiItemStyle = null;

            if (pids != null) {
                if (p.ot == SmpaPoiType.SB) {
                    if (pids.has(p.uid))
                        continue;
                } else if (p.rf != null && pids != null)
                    pids.add(p.rf);
            }


            if (mostRecent)
                if (p.rf == -1) {
                    if (p.ib)
                        this.lastBuPoi = p;
                    else
                        this.lastBePoi = p;
                } else {
                    if (p.ib)
                        this.lastReBuPoi = p;
                    else
                        this.lastReBePoi = p;
                }
            if (this.recentPoi == null || p.t.t > this.recentPoi.t.t)
                this.recentPoi = p;

            if (maxpois-- <= 0)
                break;
            p.type = isBos ? PoiToolType.LastBos : (mostRecent ? PoiToolType.MostRecent : PoiToolType.Old);
            let style: styleSet;

            if (p.ot == SmpaPoiType.MB || p.ot == SmpaPoiType.BB) {
                p.ot = markTools.isBreaker(p) ? SmpaPoiType.BB : SmpaPoiType.MB;
                p.m.n = SmpaPoiType[p.ot];
            }
            switch (p.ot) {
                case SmpaPoiType.SB:
                    style = this.styles.sbpoi;
                    break;
                case SmpaPoiType.MB:
                    style = this.styles.mbpoi;
                    break;
                case SmpaPoiType.BB:
                    style = this.styles.bbpoi;
                    break;
                default:
                    style = this.styles.obpoi;
                    break;
            }

            const tstyle = style.style as PoiItemStyle;
            withBosStyle ??= tstyle;
            const dib = p.ib ? 1 : 0;
            let from = p.f;
            let to: tvpoint = null;
            if (withBosStyle.style == PoiStyle.Blocks) {
                const poi = new rectTool(this.tvd, style.get(p.ib), LineWidth.w0, color_transparent);
                to = { t: p.eb, p: p.t.p };
                if (p.bd)
                    to.p = p.bd.p;
                switch (withBosStyle.ext) {
                    case PoiExtend.ByStart:
                        to.t = p.psb;
                        break;
                    case PoiExtend.ByEnd:
                        to.t = p.peb;
                        break;
                    case PoiExtend.ByClosestPrice:
                        to.t = p.ptb;
                        break;
                    case PoiExtend.ByTestOrRT:
                        if (markTools.isTestInPoi(p))
                            to.t = p.ptb;
                        else
                            to.t = mi.lb;
                        break;
                    case PoiExtend.ByRT:
                        to.t = mi.lb;
                        break;
                }
                poi.build(from, to);
                this.tools.addDirTool(style, poi, p.ib, false, p);
                if (hub.debugApi) {
                    this.buildPoiDebug(poi, mi, p);
                }
            } else {
                const poi = new tlTool(this.tvd, style.getText(p.ib), tstyle.lWidth, color_transparent, tstyle.lStyle);
                to = {
                    t: p.t.t,
                    p: from.p
                };
                poi.build(from, to);

                this.tools.addDirTool(style, poi, p.ib);
            }
            if (tstyle.txtOn) {
                let txtkey: string = null;
                if (tstyle.txtAl == TxtAlign.Left)
                    txtkey = from.t.toString();
                else if (tstyle.txtAl == TxtAlign.Right)
                    txtkey = to.t.toString();
                let txt: tlTool = null;
                if (txtkey) {
                    txtkey += to.p;
                    txt = drawnPoiLabels[dib].get(txtkey);
                }
                if (txt == null) {
                    txt = new tlTool(this.tvd, color_transparent, LineWidth.w1, style.getText(p.ib), LineStyle.solid);
                    let align = !p.ib;
                    if (withBosStyle.style == PoiStyle.Lines)
                        align = !align;

                    txt.setAligns(align ? valign_top : valign_bottom, markTools.getAlign(tstyle), tstyle.txtSz);
                    txt.build({
                        p: to.p,
                        t: from.t
                    }, {
                        p: to.p,
                        t: to.t
                    });
                    this.tools.addDirTool(style, txt, p.ib, true);
                    //this.tools.addPoiText(poiType, txt, p.ib);
                    txt.setText(markTools.getName(mi, p));
                    if (txtkey != null)
                        drawnPoiLabels[dib].set(txtkey, txt);
                } else {
                    txt.setText(`${txt.getText()},${markTools.getName(mi, p)}`);
                }
            }
            this.drawnTools.add(p.uid);
        }
    }

    private isParentVisible(p: SmpaZoneInfo) {
        if (!p.bf && !p.ff && !p.af && !p.inf)
            return true;

        if (p.bf) for (var i of p.bf) if (this.drawnTools.has(i)) return true;
        if (p.ff) for (var i of p.ff) if (this.drawnTools.has(i)) return true;
        if (p.af) for (var i of p.af) if (this.drawnTools.has(i)) return true;
        if (p.inf) for (var i of p.inf) if (this.drawnTools.has(i)) return true;

        return false;
    }
    private buildFvg(mi: SmpaTFInfo, p: SmpaFvgInfo, target: boolean) {
        if (this.drawnTools.has(p.uid))
            return true;
        this.drawnTools.add(p.uid);
        let fillPrice = p.f.p + p.fl * (p.ib ? -1 : 1);
        const fs = hub.smcConfig.fvg;
        let isff = markTools.isFF(p);
        const u_style = p.fl == 0 ? this.styles.fvg_u : this.styles.fvg_upf;
        const f_style = isff ? this.styles.fvg_ff : this.styles.fvg_f;
        let fto = p.t.t;
        const uto = {
            t: p.t.t,
            p: p.t.p
        };
        let ext = fs.ext;
        if (isff)
            ext = fs.extFF;
        switch (ext) {
            case FvgExtend.ByRT:
                uto.t = mi.lb;
                break;
            case FvgExtend.ByTest:
                if (p.tp)
                    uto.t = p.tp.t;
                break;
        }
        if (isff)
            fto = uto.t;
        else if (fs.extFByU)
            fto = uto.t;


        if (f_style.on && p.fl != 0) {
            const poi = new rectTool(this.tvd, f_style.get(p.ib),
                LineWidth.w1,
                f_style.getText(p.ib),
                true,
                false,
                false);
            poi.build(p.f, {
                t: fto,
                p: fillPrice
            });
            this.tools.addDirTool(f_style, poi, p.ib);
        }
        if (p.t.p != fillPrice && !isff && (u_style.on || target)) {
            const poi = new rectTool(this.tvd,
                u_style.get(p.ib),
                LineWidth.w1,
                u_style.getText(p.ib),
                true,
                false,
                true);
            const pt = {
                t: p.f.t,
                p: fillPrice
            };
            poi.build(pt, uto);
            this.tools.addDirTool(u_style, poi, p.ib);
        }
        const tstyle = isff ? f_style : u_style;
        if (fs.txtOn && (tstyle.on || target)) {
            const pt = {
                t: p.t.t,
                p: (p.f.p + p.t.p) / 2
            };

            switch (ext) {
                case FvgExtend.ByRT:
                    pt.t = mi.lb;
                    break;
                case FvgExtend.ByTest:
                    if (p.tp)
                        pt.t = p.tp.t;
                    break;
            }

            if (p.fl != 0 && p.t.p != fillPrice)
                pt.p = (p.t.p + fillPrice) / 2;
            const poi = new tlTool(this.tvd, color_transparent, 1, tstyle.getText(p.ib));
            const ts = tstyle.style as TextStyle;
            poi.setAligns(valign_center, halign_left, ts.txtSz);
            poi.build(pt, pt);
            poi.setText(markTools.getName(mi, p));
            this.tools.addDirTool(tstyle, poi, p.ib, true);
        }
        return true;
    }

    private buildFvgs(mi: SmpaTFInfo, vals: SmpaFvgInfo[]) {
        if (this.styles.fvg_u.on) {
            for (const p of vals) {
                if (markTools.isFF(p) && !this.isParentVisible(p))
                    continue;
                this.buildFvg(mi, p, false);
            }
        }
    }
    private buildSessions(vals: SmpaSessionInfo[]) {
        if (this.styles.sessionsOn)
            for (const p of vals) {
                let color = this.styles.asesColor;
                if (p.n == LevelLiqType.F)
                    color = this.styles.fsesColor;
                else if (p.n == LevelLiqType.L)
                    color = this.styles.lsesColor;
                else if (p.n == LevelLiqType.N)
                    color = this.styles.nsesColor;

                const poi = new rectTool(this.tvd, color, 1, null, true);
                poi.build(p.f, p.t);
                this.tools.addSession(poi, p.n);
            }
    }
    private attachSweepLevel(mi: SmpaTFInfo, isbull: boolean, ls: LevelLiqType) {
        if (!hub.smcConfig.level.on || ls == LevelLiqType.None)
            return;
        for (const lvl of (isbull ? mi.levels.bu : mi.levels.be)) {
            if (!isSet(ls, lvl.n))
                continue;
            if (lvl.m.c == MarkToolCat.Level) {
                if (!hub.smcConfig.level.on)
                    continue;
            } else if (lvl.m.c == MarkToolCat.Sessions) {
                if (!hub.smcConfig.sessions.on)
                    continue;
            }
            this.drawnTools.add(lvl.uid);
        }
    }
    //private buildInsideFvgs(mi: SmpaTFInfo, tool: SmpaSweepInfo) {
    //    if (tool.i)
    //        for (const inside of tool.i)
    //            if (inside.t == MarkToolCat.Fvg && inside.tf == mi.tf_tv) {
    //                //const x = (tool.ib ? mi.fvgs.bu : mi.fvgs.be).get
    //                //this.buildFvg(mi,)
    //            }
            
    //}
    private buildSweeps(mi: SmpaTFInfo, vals: SmpaSweepInfo[]) {
        const ss = hub.smcConfig.sweep;
        const rs = hub.smcConfig.raid;
        for (const p of vals) {
            if (this.drawnTools.has(p.uid))
                continue;
            const s: RaidableToolStyle = markTools.isRaid(p) ? rs : ss;
            const cset = markTools.isRaid(p) ? this.styles.raid : this.styles.sweep;
            if (!cset.on)
                continue;

            if (p.t.t < this.lastBosAt || markTools.isRaid(p))
                if (!this.isParentVisible(p))
                    continue;
            if (p.el != LevelLiqType.None && s.txtOn)
                this.attachSweepLevel(mi, p.ib, p.el);
            if (p.ol != LevelLiqType.None && s.txtOn)
                this.attachSweepLevel(mi, p.ib, p.ol);
            this.drawnTools.add(p.uid);
            let poi = new tlTool(this.tvd, cset.get(p.ib), s.lWidth, cset.getText(p.ib), s.lStyle);
            poi.setAligns(p.ib ? valign_bottom : valign_top, markTools.getAlign(s), s.txtSz);
            poi.build(p.f, p.t);
            if (s.txtOn)
                poi.setText(markTools.getName(mi, p));
            this.tools.addDirTool(cset, poi, p.ib);
            if (p.tdp) {
                poi = new tlTool(this.tvd, cset.get(p.ib), s.lWidth, cset.getText(p.ib), s.lStyle);
                poi.build(p.tdp, {
                    t: p.f.t,
                    p: p.tdp.p
                });
                this.tools.addDirTool(cset, poi, p.ib);
            }

            //this.buildInsideFvgs(mi, p);
        }
    }
    private buildLevels(mi: SmpaTFInfo, vals: SmpaLevelInfo[]) {
        if (!this.styles.level.on)
            return;
        const s = hub.smcConfig.level;
        for (let i = 0; i < vals.length; i++) {
            const p = vals[i];
            if (p.n >= LevelLiqType.A)//skip all session levels
                continue;
            if (this.drawnTools.has(p.uid))
                continue;
            switch (p.n) {
                case LevelLiqType.PD:
                    if (!s.day)
                        continue;
                    break;
                case LevelLiqType.PW:
                    if (!s.week)
                        continue;
                    break;
                case LevelLiqType.PM:
                    if (!s.month)
                        continue;
                    break;
            }
            this.drawnTools.add(p.uid)
            let n = markTools.getName(mi, p);
            for (let j = i + 1; j < vals.length; j++)
                if (p.f.p == vals[j].f.p) {
                    this.drawnTools.add(vals[j].uid)
                    n += ',' + markTools.getName(mi, vals[j]);
                }
            const poi = new tlTool(this.tvd, this.styles.level.get(p.ib), s.lWidth, this.styles.level.getText(p.ib), s.lStyle);
            if (markTools.isSwept(p))
                poi.setAligns(p.ib ? valign_bottom : valign_top, markTools.getAlign(s), s.txtSz);
            else
                poi.setAligns(valign_center, markTools.getAlign(s), s.txtSz);
            poi.build(p.f, p.t);
            if (s.txtOn)
                poi.setText(n);
            this.tools.addDirTool(this.styles.level, poi, p.ib);
        }
    }
    private buildOpens(mi: SmpaTFInfo, vals: SmpaOpenInfo[]) {
        function getSet(t: markTools, i: number): { s: styleSet, d: OpenToolStyle, on: boolean } {
            let r = { s: t.styles.open, d: hub.smcConfig.open, on: false };
            switch (vals[i].n) {
                case MarkOpenType.DO:
                    r.on = r.d.day;
                    break;
                case MarkOpenType.WO:
                    r.on = r.d.week;
                    break;
                case MarkOpenType.NO:
                    r.on = r.d.ny;
                    break;
                case MarkOpenType.MO:
                    r.on = r.d.month;
                    break;
            }
            return r;
        }
        if (hub.smcConfig.open.on)
            for (let i = 0; i < vals.length; i++) {
                const cset = getSet(this, i);
                if (!cset.on)
                    continue;
                const p = vals[i];
                if (this.drawnTools.has(p.uid))
                    continue;
                this.drawnTools.add(p.uid);
                let n = markTools.getName(mi, p);
                for (let j = i + 1; j < vals.length; j++) {
                    const lcset = getSet(this, j);
                    if (lcset == null || !lcset.d.on)
                        continue;
                    if (p.f.p == vals[j].f.p) {
                        this.drawnTools.add(vals[j].uid);
                        n += ',' + markTools.getName(mi, vals[j]);
                    }
                }

                const poi = new tlTool(this.tvd, cset.s.get(false), cset.d.lWidth, cset.s.getText(false), cset.d.lStyle);
                const tstyle = cset.s.style as TextStyle;
                poi.setAligns(valign_center, markTools.getAlign(tstyle), tstyle.txtSz);
                poi.build(p.f, p.t);
                if (cset.d.txtOn)
                    poi.setText(n);
                this.tools.addDirTool(cset.s, poi, false);
            }
    }
    private buildBuildUps(mi: SmpaTFInfo, vals: SmpaBuildUpInfo[]) {
        for (let i = 0; i < vals.length; i++) {
            const p = vals[i];
            switch (p.m.c) {
                case MarkToolCat.Eq:
                    if (!hub.config.chart.smpa.eqLiq.on)
                        continue;
                    break;
                case MarkToolCat.Cascade:
                    if (!hub.config.chart.smpa.caLiq.on)
                        continue;
                    break;
                default:
                    continue;
            }
            this.buildBuildUp(mi, p);
        }
    }
    private buildBuildUp(mi: SmpaTFInfo, p: SmpaBuildUpInfo) {
        if (!p.ps)
            return;
        if (this.drawnTools.has(p.uid))
            return;
        const style = p.m.c == MarkToolCat.Eq ? hub.smcConfig.eqLiq : hub.smcConfig.caLiq;

        p.re = null;
        let lastP = 0;
        let lastK = 0;
        for (let i = 0; i < p.ps.length; i++) {
            if (p.ps[i].k <= style.dk && (style.s == PivotSignificance.Ignore || (p.ps[i].s & style.s) != 0))
                continue;
            lastK += p.ps[i].k;
            const pi = i - 1;
            if (pi - lastP < 1) {
                lastP = i + 1;
                continue;
            }

            p.re ??= [];
            const pts = p.ps.slice(lastP, i);
            if (lastK < style.dk && p.re.length > 0)
                p.re[p.re.length - 1] = p.re[p.re.length - 1].concat(pts);
            else
                p.re.push(pts);

            lastP = i + 1;
            lastK = 0;
        }
        if (p.ps.length - 1 - lastP >= 1) {
            p.re ??= [];
            const pts = p.ps.slice(lastP, p.ps.length);
            if (lastK < style.dk && p.re.length > 0)
                p.re[p.re.length - 1] = p.re[p.re.length - 1].concat(pts);
            else
                p.re.push(pts);
        }
        if (p.re == null || p.re?.length == 0)
            return;

        const st = {
            s: p.m.c == MarkToolCat.Eq ? this.styles.eq_s : this.styles.ca_s,
            us: p.m.c == MarkToolCat.Eq ? this.styles.eq_us : this.styles.ca_us,
            e: p.m.c == MarkToolCat.Eq ? this.styles.eq_e : this.styles.ca_e
        };

        this.drawnTools.add(p.uid);
        for (let ps of p.re) {
            for (let i = 0; i < ps.length; i++) {
                if (i > 0) {
                    let s: styleSet = null;
                    if (!ps[i].is && st.us.on)
                        s = st.us;
                    else if (ps[i].is && st.s.on)
                        s = st.s;
                    if (s != null) {
                        const key = ps[i - 1].t + ps[i].t;
                        if (this.drawnBuildUps.has(key))
                            continue;
                        const ss = s.style as BuildUpItemToolStyle;
                        const poi = new tlTool(this.tvd, s.get(p.ib), ss.lWidth, s.getText(p.ib), ss.lStyle);
                        poi.setAligns(p.ib ? valign_bottom : valign_top, markTools.getAlign(ss), ss.txtSz);

                        poi.build(ps[i - 1], ps[i]);
                        this.tools.addDirTool(s, poi, p.ib);
                        this.drawnBuildUps.set(key, poi);
                    }
                }

                if (!ps[i].is && st.e.on && !this.drawnBuildUpLevels.has(ps[i].t)) {
                    const ss = st.e.style as BuildUpItemToolStyle;
                    const poi = new hrTool(this.tvd, st.e.get(p.ib), ss.lWidth, null, ss.lStyle, null, false);
                    poi.build(ps[i]);
                    this.tools.addDirTool(st.e, poi, p.ib);
                    this.drawnBuildUpLevels.add(ps[i].t);
                }
            }
            const txtStyle: styleSet = markTools.isSwept(p) ? st.s : st.us;
            if (txtStyle?.on) {
                //const ss = txtStyle.style as BuildUpItemToolStyle;

                let i0 = p.i0;
                let i1 = p.i1;
                if (ps.length > 1)
                    i0 = ps[ps.length - 2];
                i1 = ps[ps.length - 1];

                const key = i0.t + i1.t;
                const poi = this.drawnBuildUps.get(key);
                if (poi == null)
                    continue;

                let text = poi.getText();
                const n = markTools.getName(mi, p);
                if (!text)
                    text = n;
                else
                    text = `${text},${n}`;

                poi.setText(text);
            }
        }
    }
    public static getAlign(props: TextStyleProps) {
        switch (props.txtAl) {
            case TxtAlign.Center:
                return halign_center;
            case TxtAlign.Right:
                return halign_right;
            case TxtAlign.Left:
                return halign_left;
            default:
                return halign_right;
        }
    }

    private getFvgTargetPrice(fvg: SmpaFvgInfo, fvgDist: number) {
        const fillPrice = fvg.f.p + fvg.fl * (fvg.ib ? -1 : 1);
        const distPrice = fvg.f.p - (fvg.f.p - fvg.t.p) * fvgDist / 100.0;
        const price = fvg.ib ? Math.min(fillPrice, distPrice) : Math.max(fillPrice, distPrice);
        return price;
    }

    private buildTargets(mi: SmpaTFInfo, bias: boolean) {
        const s = hub.smcConfig.targets;
        const fs = hub.smcConfig.targetFvg;
        const bs = hub.smcConfig.targetBuildUp;
        const ss = hub.smcConfig.targetSwng;
        let maxBu = s.max;
        let maxBe = s.max;
        let visible = new Set<number>();
        for (const tg of mi.tgs) {
            if (maxBu == 0 && maxBe == 0)
                break;
            let p: SmpaTargetInfo = null;
            if (tg.c == MarkToolCat.TgFvg) {
                p = mi.fvgTgs[tg.i];
                if (bias != null && bias != p.ib)
                    continue;
                if (!fs.on)
                    continue;
            } else if (tg.c == MarkToolCat.TgBuildUp) {
                p = mi.buildUpTgs[tg.i];
                if (bias != null && bias != p.ib)
                    continue;
                if (!bs.on)
                    continue;
            } else if (tg.c == MarkToolCat.TgSwng) {
                p = mi.swngTgs[tg.i];
                if (bias != null && bias != p.ib)
                    continue;
                if (!ss.on)
                    continue;
            } else {
                continue;
            }
            if (p.ib) {
                if (maxBu == 0)
                    continue
            } else {
                if (maxBe == 0)
                    continue;
            }
            let pt: tvpoint = null;

            let name = markTools.getName(mi, p);
            const fvg = markTools.findToolByUId(mi.fvgs, !p.ib, p.fm);
            if (fvg != null) {
                if (visible.has(fvg.f.t))
                    continue;
                pt = {
                    t: fvg.t.t,
                    p: this.getFvgTargetPrice(fvg, fs.fvgDist)
                };
                if (visible.has(pt.p))
                    continue;
                if (s.txtFlgs == TargetsTxtFlgs.Tools)
                    name = markTools.getName(mi, fvg);
                if (!this.buildFvg(mi, fvg, true))
                    continue;
                visible.add(fvg.f.t);
                visible.add(pt.p);
            }
            if (tg.c == MarkToolCat.TgBuildUp) {
                const buildUp = markTools.findToolByUId(mi.buildUps, !p.ib, (p as SmpaBuildUpTargetInfo).tm);
                if (buildUp?.ps == null || buildUp.ps.length == 0)
                    continue;
                let skip = false;
                for (const pt of buildUp.ps) {
                    if (visible.has(pt.t) || visible.has(pt.p)) {
                        skip = true;
                        break;
                    }
                }
                if (skip)
                    continue;
                buildUp.ps.forEach(x => { visible.add(x.t); visible.add(x.p); });
                switch (buildUp.m.c) {
                    case MarkToolCat.Eq:
                        if (!hub.smcConfig.eqLiq.on)
                            continue;
                        break;
                    case MarkToolCat.Cascade:
                        if (!hub.smcConfig.caLiq.on)
                            continue;
                        break;
                }

                this.buildBuildUp(mi, buildUp);

                if (s.txtFlgs == TargetsTxtFlgs.Tools)
                    name = markTools.getName(mi, buildUp);
                const ptL = buildUp.ps[0];
                const ptR = buildUp.ps[buildUp.ps.length - 1];
                let time = ptR.t;
                const price = ptR.p - (ptR.p - ptL.p) * hub.smcConfig.targetBuildUp.dist / 100.0;
                for (let i = buildUp.ps.length - 1; i > 0; i--) {
                    const pt0 = buildUp.ps[i - 1];
                    const pt1 = buildUp.ps[i];
                    const low = pt0.p < pt1.p ? pt0.p : pt1.p;
                    const high = pt0.p > pt1.p ? pt0.p : pt1.p;
                    if (price >= low && price <= high) {
                        let c = p.ib ? 0.0 : 1.0;
                        if (high - low != 0)
                            c = (price - low) / (high - low);
                        if (p.ib)
                            time = (pt0.t + (1 - c) * (pt1.t - pt0.t));
                        else
                            time = (pt0.t + c * (pt1.t - pt0.t));
                        break;
                    }
                }
                if (pt) {
                    pt.t = time;
                    pt.p = price;
                } else {
                    pt = {
                        t: time,
                        p: price
                    };
                }
            } else if (tg.c == MarkToolCat.TgSwng) {
                pt = (p as SmpaBuildUpTargetInfo).pv;
                if (pt == null || visible.has(pt.t) || visible.has(pt.p))
                    continue;
                if (s.txtFlgs == TargetsTxtFlgs.Tools)
                    name = 'p';
                visible.add(pt.t);
                visible.add(pt.p);
            }

            //if (this.drawnTargets.has(pt.p))
            //	continue;
            //this.drawnTargets.add(pt.p);


            let color = this.styles.targets.get(p.ib);
            let lstyle = s.lStyle;
            if (lstyle == LineStyle.none) {
                lstyle = LineStyle.solid;
                color = color_transparent;
            }
            const poi = new hrTool(this.tvd, color, s.lWidth, false, lstyle, this.styles.targets.getText(p.ib));
            poi.setAligns(valign_center, markTools.getAlign(s), s.txtSz);
            poi.build(pt);
            if (s.txtOn)
                poi.setText(name);

            this.tools.addDirTool(this.styles.targets, poi, p.ib);
            if (p.ib)
                maxBu--;
            else
                maxBe--;
        }
    }
    buildTopMost(mi: SmpaTFInfo) {
        this.buildMarkUp(mi);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    build(mi: SmpaTFInfo, bias: boolean, viewUpdate: boolean) {
        this.clear();
        if (mi == null)
            return;
        this.recentPoi = null;
        this.lastBosAt = 0;
        this.lastBePoi = null;
        this.lastBuPoi = null;
        this.lastReBePoi = null;
        this.lastReBuPoi = null;
        const drawnPoiLabels: Map<string, tlTool>[] = [new Map<string, tlTool>(), new Map<string, tlTool>()];


        this.buildPremiumDiscount(mi, bias);

        if (bias == null || bias)
            this.buildPOIs(mi, mi.pois.bu, drawnPoiLabels);
        if (bias == null || !bias)
            this.buildPOIs(mi, mi.pois.be, drawnPoiLabels);
        if (bias == null || bias)
            this.buildSweeps(mi, mi.sweeps.bu);
        if (bias == null || !bias)
            this.buildSweeps(mi, mi.sweeps.be);
       
        this.buildOpens(mi, mi.opens);

        if (bias == null || bias)
            this.buildLevels(mi, mi.levels.bu);
        if (bias == null || !bias)
            this.buildLevels(mi, mi.levels.be);
        if (bias == null || bias)
            this.buildBuildUps(mi, mi.buildUps.bu);
        if (bias == null || !bias)
            this.buildBuildUps(mi, mi.buildUps.be);

        if (bias == null || bias)
            this.buildFvgs(mi, mi.fvgs.bu);
        if (bias == null || !bias)
            this.buildFvgs(mi, mi.fvgs.be);

        if (this.tvd.targetsPreview && this.styles.targets.on) {
            if (this.tvd.targetsPreview == TargetsPreview.Bullish)
                bias = true;
            else if (this.tvd.targetsPreview == TargetsPreview.Bearish)
                bias = false;
            this.buildTargets(mi, bias);
        }
        this.buildSessions(mi.sessions);
        const drawn = new Map<number, IDrawn>();
        this.structs.forEach(x => x.build(mi, drawn));

        this.tvd.tv.clearUndoHistory();
    }

    clear() {
        this.drawnTools.clear();
        this.drawnBuildUps.clear();
        this.drawnBuildUpLevels.clear();
        this.tools.clear();
        this.structs.forEach(x => x.clear());

    }

    static isInPoi(tool: SmpaToolInfo) {
        return (tool.fg & 2) != 0;
    }

    static isBasedOn(tool: SmpaToolInfo, zone: SmpaToolBase) {
        if (!tool.bf)
            return false;
        for (const t of tool.bf)
            if (t == zone.uid)
                return true;
        return false;
    }
    static respectsPremium(tool: SmpaToolInfo) {
        return (tool.fg & 8) != 0;
    }
    static isAwait(tool: SmpaToolInfo, zone: SmpaToolBase) {
        let r = false;
        if (tool.af)
            for (const t of tool.af)
                if (t == zone.uid) {
                    r = true;
                    break;
                }
        return r;
    }
    static isFavor(tool: SmpaToolInfo, zone: SmpaToolBase) {
        let r = false;
        if (tool.ff)
            for (const id of tool.ff)
                if (id == zone.uid) {
                    r = true;
                    break;
                }
        return r;
    }
    static hasInside(tool: SmpaFvgInfo | SmpaStructPoiInfo | SmpaSweepInfo | SmpaBuildUpInfo) {
        return (tool.fg & 64) != 0;
    }
    static isSwept(tool: SmpaBuildUpInfo | SmpaLevelInfo) {
        return (tool.fg & 128) != 0;
    }
    static isFF(tool: SmpaBuildUpInfo | SmpaFvgInfo) {
        return (tool.fg & 256) != 0;
    }
    static isRaid(tool: SmpaSweepInfo) {
        return (tool.fg & 128) != 0;
    }
    static isRecentConfirm(tool: SmpaSweepInfo) {
        return (tool.fg & 256) != 0;
    }

    static isWeakTest(tool: SmpaStructPoiInfo) {
        return !isSet(tool.fg, 128) && (isSet(tool.fg, 256) || isSet(tool.fg, 512));
    }
    static isStrongTest(tool: SmpaStructPoiInfo) {
        return isSet(tool.fg, 128);
    }
    static isTestInPoi(tool: SmpaStructPoiInfo) {
        return isSet(tool.fg, 8192);
    }
    static isLastBos(tool: SmpaStructPoiInfo) {
        return (tool.fg & 1024) != 0;
    }
    static isWorkedOut(tool: SmpaStructPoiInfo) {
        return (tool.fg & 2048) != 0;
    }

    static hasRefines(tool: SmpaStructPoiInfo) {
        return (tool.fg & 4096) != 0;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static getName(mi: SmpaTFInfo, p: SmpaToolMark) {
        const isSwept = markTools.isSwept(p as SmpaBuildUpInfo);
        switch (p.m.c) {
            case MarkToolCat.Level: {
                const style = hub.smcConfig.level;
                p.m.n ??= '';
                return style.txtUC ? p.m.n.toUpperCase() : p.m.n.toLowerCase();
            }
            case MarkToolCat.DO:
            case MarkToolCat.MO:
            case MarkToolCat.WO:
            case MarkToolCat.NO: {
                const style = hub.smcConfig.open;
                p.m.n ??= '';
                return style.txtUC ? p.m.n.toUpperCase() : p.m.n.toLowerCase();
            }
            case MarkToolCat.Fvg: {
                const f = p as SmpaFvgInfo;
                const style = hub.smcConfig.fvg;
                let n = p.m.n;
                if (isSet(style.txtFlgs, TF_Ids))
                    n += p.m.id;
                return style.txtUC ? n.toUpperCase() : n.toLowerCase();
            }
            case MarkToolCat.Swp:
            case MarkToolCat.Raid: {
                const f = p as SmpaSweepInfo;
                const style = p.m.c == MarkToolCat.Raid ? hub.smcConfig.raid : hub.smcConfig.sweep;
                let n = p.m.n ?? '';
                if (isSet(style.txtFlgs, TF_Ids) && p.m.id != null)
                    n += p.m.id;
                if (isSet(style.txtFlgs, TF_QMs) && f.qm)
                    if (f.qm[0] == '.') {
                        const t = f.qm.substring(1);
                        if (t)
                            n += '(' + t + ')';
                    }
                    else
                        n = f.qm;

                n = style.txtUC ? n.toUpperCase() : n.toLowerCase();

                if (isSet(style.txtFlgs, TF_Levels)) {
                    let l = addLevel(f.el, f.ib);
                    if (l) n += `.${l}`;
                    l = addLevel(f.ol, f.ib);
                    if (l) {
                        n += `+${l}`;
                        if (f.tdp)
                            n += ',tdp';
                    } else if (f.tdp) {
                        n += `+tdp`;
                    }

                }
                return n;
            }
            case MarkToolCat.Poi: {
                const f = p as SmpaStructPoiInfo;
                const st = hub.smcConfig.poi;
                let n = f.m.n ?? '';
                let style: PoiItemStyle = null;
                switch (f.ot) {
                    case SmpaPoiType.SB:
                        style = st.sb;
                        break;
                    case SmpaPoiType.MB:
                        style = st.mb;
                        break;
                    case SmpaPoiType.BB:
                        style = st.bb;
                        break;
                    default:
                        style = st.ob;
                        break;
                }
                if (isSet(style.txtFlgs, TF_Ids) && f.m.id != null)
                    n += f.m.id;
                n = style.txtUC ? n.toUpperCase() : n.toLowerCase();
                if (isSet(style.txtFlgs, TF_Levels)) {
                    let l = addLevel(f.ls, f.ib);
                    if (l) n += `.${l}`;
                }
                return n;
            }
            case MarkToolCat.Eq:
            case MarkToolCat.Cascade: {
                const f = p as SmpaBuildUpInfo;
                const style = p.m.c == MarkToolCat.Eq ? hub.smcConfig.eqLiq : hub.smcConfig.caLiq;
                let n = p.m.n ?? '';
                const ss = isSwept ? style.swept : style.unswept;
                if (isSet(ss.txtFlgs, TF_Ids))
                    n += p.m.id;
                n = ss.txtUC ? n.toUpperCase() : n.toLowerCase();
                return n;
            }
            default: {
                const style = markTools.getConfigByCat(p.m.c);
                let n = p.m.n ?? '';
                if (p.m.id != null)
                    if (!style || (style as any).txtFlgs & TF_Ids)
                        n += p.m.id;
                if (style)
                    n = (style as any).txtUC ? n.toUpperCase() : n.toLowerCase();
                return n;
            }

        }
        function addLevel(ls: LevelLiqType, isBull: boolean) {
            let lvls = null;
            for (const lvl of (isBull ? mi.levels.bu : mi.levels.be)) {
                if (!isSet(ls, lvl.n))
                    continue;
                if (lvl.m.c == MarkToolCat.Level) {
                    if (!hub.smcConfig.level.on)
                        continue;
                } else if (lvl.m.c == MarkToolCat.Sessions) {
                    if (!hub.smcConfig.sessions.on)
                        continue;
                }
                const n = markTools.getName(mi, lvl);
                if (lvls)
                    lvls += ',' + n;
                else
                    lvls = n;
            }
            return lvls;
        }
    }

    public static findToolByUId2<TToolInfo extends SmpaToolInfo>(tools: TToolInfo[], uid: number) {
        for (const tool of tools)
            if (tool.uid == uid)
                return tool;
        return null;
    }

    public static findToolByUId<TToolInfo extends SmpaToolInfo>(tools: SmpaToolInfoTools<TToolInfo>, ib: boolean, uid: number) {
        for (const tool of (ib ? tools.bu : tools.be))
            if (tool.uid == uid)
                return tool;
        return null;
    }
    private static bbsign = (PoiSignificance.Reversal | PoiSignificance.AnySweep | PoiSignificance.SweepCa | PoiSignificance.SweepPv5 | PoiSignificance.SweepEq | PoiSignificance.SweepSwng);
    static isBreaker(poi: SmpaStructPoiInfo) {
        //if (poi.ot != SmpaPoiType.MB)
        //	return false;

        const disp = hub.smcConfig;
        if (disp.poi.s != PoiSignificance.Ignore) {
            const s = disp.poi.s & markTools.bbsign;
            return (s & poi.s) != 0;
        } else {
            return (markTools.bbsign & poi.s) != 0;
        }
    }
    static getConfigByCat(c: MarkToolCat): ToolStyle {
        const disp = hub.smcConfig;
        switch (c) {
            case MarkToolCat.Poi:
                return disp.poi;
            case MarkToolCat.Fvg:
                return disp.fvg;
            case MarkToolCat.Swp:
                return disp.sweep;
            case MarkToolCat.Raid:
                return disp.raid;
            case MarkToolCat.TgBuildUp:
                return disp.targets;
            case MarkToolCat.TgFvg:
                return disp.targets;
            case MarkToolCat.TgSwng:
                return disp.targets;
            case MarkToolCat.Eq:
                return disp.eqLiq;
            case MarkToolCat.Cascade:
                return disp.caLiq;
            case MarkToolCat.Level:
                return disp.level;
            case MarkToolCat.Sessions:
                return disp.sessions;
            case MarkToolCat.DO:
            case MarkToolCat.MO:
            case MarkToolCat.NO:
            case MarkToolCat.WO:
                return disp.open;
            case MarkToolCat.PremDisc:
                return disp.pd;
        }
        return null;
    }
}
